export default class Presenter {
  constructor(model, error, delay, onClose) {
    this.model = model;
    this.onClose = onClose;
    this.error = error;
    this.delay = delay;
    if (!error) {
      onClose?.();
    }
  }

  onAttach() {
    if (this.delay) {
      setTimeout(() => {
        window.location.reload();
        this.onClose?.();
      }, this.delay);
    }
  }

  onCloseClick() {}
}
